import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=d1316672&scoped=true"
import script from "./bindWechat.vue?vue&type=script&lang=ts"
export * from "./bindWechat.vue?vue&type=script&lang=ts"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=d1316672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1316672",
  null
  
)

export default component.exports